<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid" />Questions
      </slot>
      <div class="float-right">
        <router-link :to="{ name: 'QuestionCreate'}">
          <button class="btn btn-success m-1">Create Question</button>
        </router-link>
        <router-link :to="{ name: 'QuestionImport'}">
          <button class="btn btn-secondary">Import Question</button>
        </router-link>
      </div>
       <CRow>
        <CCol sm="6">
          <div class="form-group">
            <label>Category</label>
            <select class="form-control" v-model="selected_category" @change="getTopics">
              <option value="" disabled>Select Category</option>
              <option v-for="cat in categories" :value="cat.id" :key="cat.id" :class="{ 'font-weight-bold' : cat.parent==''}">
                {{ cat.name }}
              </option>
            </select>
          </div>
        </CCol>
        <CCol sm="6">
          <CSelect label="Topic" :options="topics" :value.sync="selected_topic" @change="getQuestions" />
        </CCol>
      </CRow>
    </CCardHeader>
    <CCardBody v-if="selected_topic">
      <v-client-table :data="questions" :columns="columns" :options="options">
        <template slot="approved" slot-scope="props">
          <div>
             <span v-if="props.row.approved" class="badge badge-success badge-sm">Approved</span>
            <span v-else class="badge badge-warning badge-sm">Pending</span>
          </div>
        </template>
        <template slot="action" slot-scope="props">
          <div>
            <router-link :to="{ name: 'QuestionEdit', params: {id: props.row.id}}">
              <span
                class="btn btn-warning btn-sm m-1"
                data-toggle="tooltip"
                title="Edit"
                :href="props.row.id"
              >
                <CIcon name="cil-pencil" size="sm" />
              </span>
            </router-link>
              <span @click="handleDelete(props.row.id)"
                  class="btn btn-danger btn-sm m-1"
                  data-toggle="tooltip"
                  title="Delete"
                  :href="props.row.id"
              >
                <CIcon name="cil-basket" size="sm" />
              </span>
          </div>
        </template>
      </v-client-table>
    </CCardBody>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "Questions",
  data() {
    return {
      questions: [],
      selected_category: '',
      selected_topic: '',
      categories: [{ value: 0, label: 'Select Category'}],
      topics: [{ value: 0, label: 'Select Topic'}],
      columns: ["id", "bangla", "type", "approved", "action"],
      options: {
        headings: {
          english: 'Question'
        },
        pagination: { nav: "fixed" },
        filterByColumn: true,
        toMomentFormat: "YYYY-MM-DD",
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    };
  },
  created() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      this.$axios
              .get(`${ADMIN_URL}/categories`)
              .then((response) => {
                this.categories = response.data.category_list
              })
              .catch((e) => {
                console.log("error occurs", e);
              });
    },
    getTopics() {
      this.topics = [{ value: 0, label: 'Select Topic'}]
      this.$axios
              .get(`${ADMIN_URL}/topics`,{
                params: {
                  category_id : this.selected_category
                }
              })
              .then((response) => {
                response.data.topic_list.forEach((e) => {
                  this.topics.push({
                    value: e.id,
                    label: e.name,
                  });
                });
              })
              .catch((e) => {
                console.log("error occurs", e);
              });
    },
    getQuestions() {
      this.$axios
        .get(`${ADMIN_URL}/questions`,{
          params: {
            topic_id : this.selected_topic
          }
        })
        .then((response) => {
          this.questions = response.data.question_list;
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    handleDelete(id) {
      // console.log('handleDelete  category_id === ', category_id);
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
      }).then(result => {
        if(result.value) {
          this.deleteQuestion(id);
        }
      }).catch(error => {
        //console.log('Sweetalert ERROR');
      });
    },
    deleteQuestion(id)
    {
      this.$axios
          .delete(`${ADMIN_URL}/questions/${id}`)
          .then((response) => {
            this.$swal("Success", response.data.message, "success");
            this.getQuestions()
          })
          .catch((error) => {
            console.log("Error  ... ", error.response);
            this.$swal("Error", error.response.message, "error");
          });
    }
  }
};
</script>
